import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const getMailTemplate = createAsyncThunk('mailTemplateSlice/getMailTemplate', async () => {
  const response = await axios.get(`GetADDetails/get-email-template`);
  return response.data;
});
export const updateMailTemplate = createAsyncThunk('mailTemplateSlice/updateMailTemplate', async (data) => {
  try {
    const response = await axios.put(`GetADDetails/UpdateEmailTemplate`, data);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
//getDomainSettingsMailTemplate
export const getDomainSettingsMailTemplate = createAsyncThunk(
  'mailTemplateSlice/getDomainSettingsMailTemplate',
  async (value) => {
    const response = await axios.get(`GetADDetails/getdomaintemplate?domainId=${value}`);
    return response.data;
  }
);
//updateDomainSettingMailTemplate
export const updateDomainSettingMailTemplate = createAsyncThunk(
  'mailTemplateSlice/updateDomainSettingMailTemplate',
  async (data) => {
    try {
      const response = await axios.put(`GetADDetails/updatedomainemailtemplate`, data);
      return { status: response.status, data: response.data };
    } catch (err) {
      return { status: err.response.status, data: err.response.data };
    }
  }
);

const initialState = {
  mailTemplateData: [],
  loading: false,
  error: null,
  domainMailTemplateData: [],
  domainMailTemplateLoading: false,
  domainMailTemplateError: null,
};

const mailTemplateSlice = createSlice({
  name: 'mailTemplate',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getMailTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMailTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.mailTemplateData = action.payload;
        state.error = null;
      })
      .addCase(getMailTemplate.rejected, (state, action) => {
        state.loading = false;
        state.mailTemplateData = [];
        state.error = action.error.message;
      })
      .addCase(getDomainSettingsMailTemplate.pending, (state) => {
        state.domainMailTemplateLoading = true;
      })
      .addCase(getDomainSettingsMailTemplate.fulfilled, (state, action) => {
        state.domainMailTemplateLoading = false;
        state.domainMailTemplateData = action.payload;
        state.domainMailTemplateError = null;
      })
      .addCase(getDomainSettingsMailTemplate.rejected, (state, action) => {
        state.domainMailTemplateLoading = false;
        state.domainMailTemplateData = [];
        state.domainMailTemplateError = action.error.message;
      });
  },
});
export default mailTemplateSlice.reducer;
